import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Modal, Button } from 'react-bootstrap';
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { IoMdDownload } from "react-icons/io";
import { AiOutlineMail } from "react-icons/ai";
import { FaRegEye } from "react-icons/fa";

import NoPhoto from '../Medias/LibImages/img-placeholder-bk.png';
import Photo1 from '../Medias/Photos/1649677030_0.jpg'
import Photo2 from '../Medias/Photos/1668062467_0.jpg'
import Photo3 from '../Medias/Photos/messageImage_1722580737887.jpg'
import Photo4 from '../Medias/Photos/106967.e6d436b675a52238f35a.jpg'
import Photo5 from '../Medias/Photos/S__31219723.jpg';
import Photo6 from '../Medias/Photos/team-member_4.jpg';
import Photo7 from '../Medias/Photos/formal-photo.jpg';
import Photo8 from '../Medias/Photos/image1.png';
import Photo9 from '../Medias/Photos/1751774230955.png';
import Photo10 from '../Medias/ContentImgs/content_2025-12-01_1.jpg';

import Profile1 from '../Medias/Profiles/Consolidated-Profiles_PT_Associates-Lawyer-Profiles.pdf';
import Profile2 from '../Medias/Profiles/ProfDrTanatthepTianprasit_PT_Associates-Lawyer-Profiles.pdf';
import Profile3 from '../Medias/Profiles/PreechaLertassavavivat_PT_Associates-Lawyer-Profiles.pdf';
import Profile4 from '../Medias/Profiles/SupakarnChumchuai_PT_Associates-Lawyer-Profiles.pdf';
import Profile5 from '../Medias/Profiles/SaranBoonrak_PT_Associates-Lawyer-Profiles.pdf';
import Profile6 from '../Medias/Profiles/BenjaminSa-OngLuis_PT_Associates-Lawyer-Profiles.pdf';
import Profile7 from '../Medias/Profiles/NirawitKrainara_PT_Associates-Lawyer-Profiles.pdf';
import Profile8 from '../Medias/Profiles/PloykamonRuengchaisin_PT_Associates-Lawyer-Profiles.pdf';
import Profile9 from '../Medias/Profiles/PrapavinKlinchan_PT_Associates-Profiles.pdf';

const SectionTeam = ({ contents, hideTopic = false, bgColor = "bg-color-primary" }) => {
  const mockup = [
    {
      name: 'Dr. Tanatthep Tianprasit',
      position: 'Senior Partner',
      email: '',
      profile:
        <>
          <Row className='mb-4'>
            <Col>
              <Card className='border-0 bg-color-primary'>
                <Card.Body>
                  <Row>
                    <Col xs={4} md={3}>
                      <img src={Photo1} className='w-100' />
                    </Col>
                    <Col className='p-3 text-white'>
                      <h2 className='mb-0'>Dr. Tanatthep Tianprasit</h2>
                      <h5 className='font-header'>Senior Partner</h5>
                      <div>
                        <a href='mailto:tanatthep.t@pt-assoc.com' className='text-white text-decoration-none'>
                          <AiOutlineMail size={20} className='me-1' /> tanatthep.t@pt-assoc.com
                        </a>
                        <a href={Profile2} target='_blank' className='ms-3 text-white text-decoration-none'>
                          <IoMdDownload size={20} className='me-1' />Download Profile
                        </a>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={4} className='px-4'>
              <h5 className='font-header fw-bold'>Education</h5>
              <ul className='ps-4'>
                <li>Ph.D. in Criminal Law and Criminal Justice, School of Law, University of Aberdeen, Scotland, 2018</li>
                <li>LL.M. in Intellectual Property Law, Queen Mary, University of London, United Kingdom, 2008</li>
                <li>LL.M. in Criminal Law and Criminal Justice, Chulalongkorn University, 2006</li>
                <li>LL.B., Thammasat University, 2000</li>
              </ul>
              <h5 className='font-header fw-bold'>Languages</h5>
              <ul className='ps-4'>
                <li>Thai</li>
                <li>English</li>
              </ul>
              <h5 className='font-header fw-bold'>Professional Affiliations</h5>
              <ul className='ps-4'>
                <li>Attorney at Law<br />
                  Lawyers Council of Thailand</li>
                <li>Graduate School of Law (GSL),<br />
                  National Institute of Development Administration (NIDA)<br />
                  Associate Dean for Planning Research and Innovation</li>
              </ul>
              <h5 className='font-header fw-bold'>Latest Publications</h5>
              <ul className='ps-4'>
                <li>Law Regarding Cannabis: The Overseas Experience<br />
                  Nitipat NIDA Law Journal (2019)</li>
                <li>The Protection of Geographical Indications in ASEAN Community<br />
                  NIDA Development Journal (2016)</li>
              </ul>
            </Col>
            <Col xs={12} md={8} className='px-4'>
              <h5 className='font-header fw-bold'>Biography</h5>
              <p>Dr. Tanatthep Tianprasit a senior partner at PT & Associates who is a renowned expert in criminal law especially in the fields of corporate and organized crimes. He provides the management guidance for other lawyers working on a range of transactions as required by various clients of PT & Associates.</p>
              <h5 className='font-header fw-bold'>Experience Highlights</h5>
              <p>Dr. Tanatthep has a distinguished career both in legal practice and in academic institutions particularly with his extensive experience addressing risks associated with criminal liabilities of a project and business models proposed by our clients. His foresight into risk mitigating strategies has resulted to invaluable client advice for the core as well as ancillary practice fields of PT & Associates. Apart from his numerous previous publications, his recent works focus on mitigating potential civil, criminal, and administrative liabilities related to personal data.</p>
            </Col>
          </Row>
        </>,
      row_value: Photo1,
      download: Profile2,
      enableDownload: true,
      enagleView: true,
    },
    // {
    //   name: 'Preecha Lertassavavivat',
    //   position: 'Senior Lawyer',
    //   email: '',
    //   profile: <>
    //     <Row className='mb-4'>
    //       <Col>
    //         <Card className='border-0 bg-color-primary'>
    //           <Card.Body>
    //             <Row>
    //               <Col xs={4} md={3}>
    //                 <img src={Photo8} className='w-100' />
    //               </Col>
    //               <Col className='p-3 text-white'>
    //                 <h2 className='mb-0'>Preecha Lertassavavivat</h2>
    //                 <h5 className='font-header'>Senior Lawyer</h5>
    //                 <div>
    //                   <a href='mailto:preecha.l@pt-assoc.com' className='text-white text-decoration-none'>
    //                     <AiOutlineMail size={20} className='me-1' /> preecha.l@pt-assoc.com
    //                   </a>
    //                   <a href={Profile3} target='_blank' className='ms-3 text-white text-decoration-none'>
    //                     <IoMdDownload size={20} className='me-1' />Download Profile
    //                   </a>
    //                 </div>
    //               </Col>
    //             </Row>
    //           </Card.Body>
    //         </Card>
    //       </Col>
    //     </Row>
    //     <Row>
    //       <Col xs={12} md={4} className='px-4'>
    //         <h5 className='font-header fw-bold'>Education</h5>
    //         <ul className='ps-4'>
    //           <li>LL.B. (Major in Business and Tax Laws), Chulalongkorn University, 2018</li>
    //           <li>Graduate Diploma, English for Business and Management, Thammasat University, 2008</li>
    //           <li>MBA in General Business Studies, Chulalongkorn University, 2000</li>
    //           <li>B.A. in Computer Engineering, King Mongkut’s University of Technology Thonburi, 1993</li>
    //         </ul>
    //         <h5 className='font-header fw-bold'>Languages</h5>
    //         <ul className='ps-4'>
    //           <li>Thai</li>
    //           <li>English</li>
    //         </ul>
    //         <h5 className='font-header fw-bold'>Professional Affiliations</h5>
    //         <ul className='ps-4'>
    //           <li>Attorney at Law<br />
    //             Lawyers Council of Thailand</li>
    //           <li>ThinkCloud Co., Ltd. <br />
    //             Business, Digital Technology Development and Legal Consultant</li>
    //         </ul>
    //       </Col>
    //       <Col xs={12} md={8} className='px-4'>
    //         <h5 className='font-header fw-bold'>Biography</h5>
    //         <p>Preecha Lertassavavivat is a senior lawyer at PT & Associates with a highly skilled professional practice with a broad academic background, including a Master of Business Administration (MBA) in General Management, and a Bachelor of Laws (LL.B.) in Business Law from Chulalongkorn University. He also holds a Graduate Diploma in English for Business and Management from Thammasat University, and a Bachelor of Engineering in Computer Engineering from King Mongkut's University of Technology Thonburi. As a licensed lawyer in Thailand, Preecha is a trusted consultant on Artificial Intelligence (AI) and the Personal Data Protection Act (PDPA). Currently, he combines legal expertise, technological knowledge, and business insight to deliver comprehensive strategic guidance to clients of PT & Associates.</p>
    //         <h5 className='font-header fw-bold'>Experience Highlights</h5>
    //         <p>With over 20 years of experience at prominent international and local companies such as IBM, Nokia, Oracle, PTT Public Company Limited, and Advanced Info Service (AIS), Preecha has held senior roles in IT strategy, project management, software consulting, and business law.</p>
    //         <p>Preecha has a proven track record in managing large-scale technology projects, advising on enterprise software strategies, and leading training initiatives across the Asia-Pacific region.</p>
    //       </Col>
    //     </Row>
    //   </>,
    //   row_value: Photo8,
    //   download: Profile3,
    //   enableDownload: true,
    //   enagleView: true,
    // },
    // {
    //   name: 'Miss Siraporn Ouifak',
    //   position: 'IP Consultant',
    //   email: '',
    //   profile: <>Miss Siraporn Ouifak obtained her B.Sc. from the Faculty of Science (Major in Chemistry), Srinakharinwirot University in 2015 and an LL.B. from Faculty of Law, Chulalongkorn University in 2022. She is specialized in intellectual property, corporate services, provide legal advice relating to intellectual property matters. She has been handling all matters related to patents including analyzing claims relating to unprotected matters of the Patent Act., conducting IP searches in pharmaceutical field, filling new application of patent/petty patent/design as well as analyzing office actions on trademarks, and copy right. She has extensive experience in directly dealing with government agencies, such as Department of Intellectual Property (DIP), Department of Business Development (DBD) and the Ministry of Health.</>,
    //   row_value: Photo2
    // },
    // {
    //   name: 'Nontnawat Wattananont',
    //   position: 'Associate',
    //   email: '',
    //   profile: <>Nontnawat Wattananont received his LL.B. from Assumption University in 2020 and an MBA with a focus on Entrepreneurship from the University of the Thai Chamber of Commerce in 2024. As a lawyer, he has significant experience in providing consultancy in areas such as commercial law, corporate law, personal data protection, and labor law. He is proficient in drafting, reviewing, and negotiating commercial contracts, including power purchase agreements and public-private partnerships (PPP). Additionally, he has conducted research and developed legal recommendations for circular economy promotion projects aimed at intergovernmental organizations.</>,
    //   row_value: Photo3
    // },
    // {
    //   name: 'Benjamin Sa-Ong Luis',
    //   position: 'Senior Consultant',
    //   email: '',
    //   profile: <>
    //     <Row className='mb-4'>
    //       <Col>
    //         <Card className='border-0 bg-color-primary'>
    //           <Card.Body>
    //             <Row>
    //               <Col xs={4} md={3}>
    //                 <img src={Photo6} className='w-100' />
    //               </Col>
    //               <Col className='p-3 text-white'>
    //                 <h2 className='mb-0'>Benjamin Sa-Ong Luis</h2>
    //                 <h5 className='font-header'>Senior Consultant</h5>
    //                 <div>
    //                   <a href='mailto:benjamin.sl@pt-assoc.com' className='text-white text-decoration-none'>
    //                     <AiOutlineMail size={20} className='me-1' /> benjamin.sl@pt-assoc.com
    //                   </a>
    //                   <a href={Profile6} target='_blank' className='ms-3 text-white text-decoration-none'>
    //                     <IoMdDownload size={20} className='me-1' />Download Profile
    //                   </a>
    //                 </div>
    //               </Col>
    //             </Row>
    //           </Card.Body>
    //         </Card>
    //       </Col>
    //     </Row>
    //     <Row>
    //       <Col xs={12} md={4} className='px-4'>
    //         <h5 className='font-header fw-bold'>Education</h5>
    //         <ul className='ps-4'>
    //           <li>LL.M. in Business Laws (International Program) (in progress), Chulalongkorn University, 2026</li>
    //           <li>LL.M. (Dean’s Scholar Prize), Harvard Law School, 2011</li>
    //           <li>J.D. (Dean’s Medal for Academic Excellence), University of the Philippines, 2008</li>
    //           <li>B.A. in Social Sciences (Magna Cum Laude), University of the Philippines, 2003</li>
    //         </ul>
    //         <h5 className='font-header fw-bold'>Languages</h5>
    //         <ul className='ps-4'>
    //           <li>English</li>
    //           <li>Filipino</li>
    //           <li>Thai</li>
    //           <li>Bahasa Indonesia</li>
    //         </ul>
    //         <h5 className='font-header fw-bold'>Professional Affiliations</h5>
    //         <ul className='ps-4'>
    //           <li>Philippine Bar Association<br />
    //             Admitted in 2009</li>
    //           <li>Bar Association of Cambodia<br />
    //             Admitted in 2010</li>
    //         </ul>
    //         <h5 className='font-header fw-bold'>Latest Publications</h5>
    //         <ul className='ps-4'>
    //           <li>Flexicurity for the Emerging Gig Economy of Southeast Asia:<br />
    //             Comparative Analysis of Labour Law Trends in Thailand, Philippines, Indonesia, and Myanmar<br />
    //             Labour Law Research Network (LLRN) <br />
    //             International Conference (2025)<br /></li>
    //         </ul>
    //       </Col>
    //       <Col xs={12} md={8} className='px-4'>
    //         <h5 className='font-header fw-bold'>Biography</h5>
    //         <p>Benjamin Sa-Ong Luis is a senior consultant at  PT & Associates specializing in corporate mergers and acquisitions (M&As) for 15 years on energy projects, particularly in Southeast Asia requiring multi-jurisdictional finance structures. He also provided legal and management services involving asset tokenization and finance, and digital payment solutions.</p>
    //         <h5 className='font-header fw-bold'>Experience Highlights</h5>
    //         <ul className='ps-4'>
    //           <li>Advised on the dual listing of a publicly listed company on the Frankfurt Stock Exchange.</li>
    //           <li>Advised on a multi-hundred million-dollar private bond offering in Hong Kong of a publicly listed company.</li>
    //           <li>Advised on multi-hundred million-dollar share-swap transactions involving mining assets in Indonesia.</li>
    //           <li>Advised on the asset tokenization of mining assets by a publicly listed company in the Philippines compliant with regulations of the Financial Market Supervisory Authority (FINMA) in Switzerland.</li>
    //           <li>Advised on the international regulatory compliance framework for digital payment solutions provided by a Philippine company collecting global social security payments.</li>
    //           <li>Advised on M&A transactions for solar farm projects in Italy.</li>
    //         </ul>
    //       </Col>
    //     </Row>
    //   </>,
    //   row_value: Photo6,
    //   download: Profile6,
    //   enableDownload: true,
    //   enagleView: true,
    // },
    // {
    //   name: 'Nirawit Krainara',
    //   position: 'Junior Lawyer',
    //   email: '',
    //   profile: <>
    //     <Row className='mb-4'>
    //       <Col>
    //         <Card className='border-0 bg-color-primary'>
    //           <Card.Body>
    //             <Row>
    //               <Col xs={4} md={3}>
    //                 <img src={Photo7} className='w-100' />
    //               </Col>
    //               <Col className='p-3 text-white'>
    //                 <h2 className='mb-0'>Nirawit Krainara</h2>
    //                 <h5 className='font-header'>Junior Lawyer</h5>
    //                 <div>
    //                   <a href='mailto:nirawat.k@pt-assoc.com' className='text-white text-decoration-none'>
    //                     <AiOutlineMail size={20} className='me-1' /> nirawat.k@pt-assoc.com
    //                   </a>
    //                   <a href={Profile7} target='_blank' className='ms-3 text-white text-decoration-none'>
    //                     <IoMdDownload size={20} className='me-1' />Download Profile
    //                   </a>
    //                 </div>
    //               </Col>
    //             </Row>
    //           </Card.Body>
    //         </Card>
    //       </Col>
    //     </Row>
    //     <Row>
    //       <Col xs={12} md={4} className='px-4'>
    //         <h5 className='font-header fw-bold'>Education</h5>
    //         <ul className='ps-4'>
    //           <li>LL.B. (First-Class Honors), Chulalongkorn University, 2025</li>
    //         </ul>
    //         <h5 className='font-header fw-bold'>Languages</h5>
    //         <ul className='ps-4'>
    //           <li>Thai</li>
    //           <li>English</li>
    //         </ul>
    //         <h5 className='font-header fw-bold'>Academic Affiliations</h5>
    //         <ul className='ps-4'>
    //           <li>Bamrung Suvicha Apisakdi <br />
    //             Law Associates (BSA Law)<br />
    //             Intern – Bangkok, Thailand (2025)</li>
    //           <li>Office of Summary Litigation <br />
    //             Region 5 (Pathum Wan) of Thailand<br />
    //             Intern – Bangkok, Thailand (2025)</li>
    //           <li>THAC National Mediation <br />
    //             Competition 2023<br />
    //             Competitor – Negotiation Team <br />
    //             Quarter-Finalist</li>
    //         </ul>
    //         <h5 className='font-header fw-bold'>Latest Publications</h5>
    //         <ul className='ps-4'>
    //           <li>Flexicurity for the Emerging Gig Economy of Southeast Asia:<br />
    //             Comparative Analysis of Labour Law Trends in Thailand, Philippines, Indonesia, and Myanmar<br />
    //             Labour Law Research Network (LLRN) <br />
    //             International Conference (2025)<br /></li>
    //         </ul>
    //       </Col>
    //       <Col xs={12} md={8} className='px-4'>
    //         <h5 className='font-header fw-bold'>Biography</h5>
    //         <p>Nirawit Krainara is a paralegal at PT & Associates assisting in its energy and infrastructure projects practice, focusing on energy sector and public-private partnerships (PPP), with experience in administrative disputes. He is developing expertise in environmental law, and aims to integrate it with energy law to promote renewable energy (RE) projects in Thailand, contributing to the country’s sustainable development. While at Chulalongkorn University, he also served as a research assistant on a smart city development project, focusing on legal issues related to energy and water infrastructure. Through this engagement, his practice has extended to procurement law, infrastructure development, and project finance.</p>
    //         <h5 className='font-header fw-bold'>Experience Highlights</h5>
    //         <ul className='ps-4'>
    //           <li>Contributed to feasibility reports for PPP projects under a smart city initiative in Chonburi province, in collaboration with the Eastern Economic Corridor (EEC) Policy Committee and Chulalongkorn University, aiming to develop a Net Zero City through renewable energy and sustainable infrastructure.</li>
    //           <li>Contributed to legal analysis reports on eco-design regulations to support extended producer responsibility (EPR) and circular economy policy, aiming to reduce marine litter and promote environmentally friendly packaging in Thailand.</li>
    //           <li>Contributed to a legal and enforcement analysis report to support legislative reform for Thailand’s low-carbon energy transition, with a focus on the Energy Industry Act B.E. 2550 (2007) and its alignment with the Sustainable Development Goals (SDGs).</li>
    //           <li>Advised on a public-private partnership (PPP) infrastructure project involving cargo and ground support equipment (GSE) facilities at a major international airport in Thailand.</li>
    //         </ul>
    //       </Col>
    //     </Row>
    //   </>,
    //   row_value: Photo7,
    //   download: Profile7,
    //   enableDownload: true,
    //   enagleView: true,
    // },
    {
      name: 'Saran Boonrak',
      position: 'Junior Lawyer',
      email: '',
      profile: <>
        <Row className='mb-4'>
          <Col>
            <Card className='border-0 bg-color-primary'>
              <Card.Body>
                <Row>
                  <Col xs={4} md={3}>
                    <img src={Photo5} className='w-100' />
                  </Col>
                  <Col className='p-3 text-white'>
                    <h2 className='mb-0'>Saran Boonrak</h2>
                    <h5 className='font-header'>Junior Lawyer</h5>
                    <div>
                      <a href='mailto:saran.b@pt-assoc.com' className='text-white text-decoration-none'>
                        <AiOutlineMail size={20} className='me-1' /> saran.b@pt-assoc.com
                      </a>
                      <a href={Profile5} target='_blank' className='ms-3 text-white text-decoration-none'>
                        <IoMdDownload size={20} className='me-1' />Download Profile
                      </a>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4} className='px-4'>
            <h5 className='font-header fw-bold'>Education</h5>
            <ul className='ps-4'>
              <li>LL.B. (Second-Class Honors), Prince of Songkla University, 2022</li>
            </ul>
            <h5 className='font-header fw-bold'>Languages</h5>
            <ul className='ps-4'>
              <li>Thai</li>
              <li>English</li>
            </ul>
            <h5 className='font-header fw-bold'>Professional Affiliations</h5>
            <ul className='ps-4'>
              <li>Attorney at Law<br />
                Lawyers Council of Thailand</li>
              <li>Dherakupt International Law Office <br />
                Intern – Bangkok, Thailand</li>
            </ul>
            <h5 className='font-header fw-bold'>Latest Publications</h5>
            <ul className='ps-4'>
              <li>Legal Reforms to Support the Transition to Low-Carbon Energy and the Legal Analysis and Enforcement through Contemporary Issues under the Framework of SDGs submitted to the King Prajadhipok’s Institute Legal Assistant</li>
            </ul>
          </Col>
          <Col xs={12} md={8} className='px-4'>
            <h5 className='font-header fw-bold'>Biography</h5>
            <p>Saran Boonrak is a junior legal associate at PT & Associates specializing in its energy, infrastructure and government contracts, banking, and project finance practice. He previously interned for Dherakupt International Law Office directly working on legal research and preparation of commercial transaction documentation. His practice covered areas relating to renewable energy project development as well as traditional and emerging project financing strategies.</p>
            <h5 className='font-header fw-bold'>Experience Highlights</h5>
            <ul className='ps-4'>
              <li>Conducted supply chain legal research on regulatory frameworks for renewable energy development with focus on power purchase agreements (PPAs), electricity grid access, and private sector participation in the Enhanced Single Buyer (ESB) model of Thailand.</li>
              <li>Advised on the tokenization of Renewable Energy Certificates (RECs) consistent with digital asset and contract laws of Thailand, including environmental reporting standards.</li>
              <li>Advised on an environmentally friendly and sustainable packaging design initiative aimed at marine litter reduction and circular plastic use through regulatory and policy enhancement in Thailand.</li>
              <li>Participated in an inter-disciplinary feasibility study concerning low-carbon urban development initiatives through island-based infrastructure projects involving clean energy deployment, waste management, water treatment, and carbon reduction strategies.</li>
              <li>Participated in an inter-disciplinary legal reform study under the framework of the Sustainable Development Goals (SDGs), focusing on the transition to low-carbon energy systems and legal enforcement through contemporary issues, submitted to the King Prajadhipok’s Institute.</li>
            </ul>
          </Col>
        </Row>
      </>,
      row_value: Photo5,
      download: Profile5,
      enableDownload: true,
      enagleView: true,
    },
    // {
    //   name: 'Supakarn Chumchuai',
    //   position: 'Junior Lawyer',
    //   email: '',
    //   profile: <>
    //     <Row className='mb-4'>
    //       <Col>
    //         <Card className='border-0 bg-color-primary'>
    //           <Card.Body>
    //             <Row>
    //               <Col xs={4} md={3}>
    //                 <img src={Photo4} className='w-100' />
    //               </Col>
    //               <Col className='p-3 text-white'>
    //                 <h2 className='mb-0'>Supakarn Chumchuai</h2>
    //                 <h5 className='font-header'>Junior Lawyer</h5>
    //                 <div>
    //                   <a href='mailto:supakarn.c@pt-assoc.com' className='text-white text-decoration-none'>
    //                     <AiOutlineMail size={20} className='me-1' /> supakarn.c@pt-assoc.com
    //                   </a>
    //                   <a href={Profile4} target='_blank' className='ms-3 text-white text-decoration-none'>
    //                     <IoMdDownload size={20} className='me-1' />Download Profile
    //                   </a>
    //                 </div>
    //               </Col>
    //             </Row>
    //           </Card.Body>
    //         </Card>
    //       </Col>
    //     </Row>
    //     <Row>
    //       <Col xs={12} md={4} className='px-4'>
    //         <h5 className='font-header fw-bold'>Education</h5>
    //         <ul className='ps-4'>
    //           <li>LL.B., Prince of Songkla University, 2022</li>
    //         </ul>
    //         <h5 className='font-header fw-bold'>Languages</h5>
    //         <ul className='ps-4'>
    //           <li>Thai</li>
    //           <li>English</li>
    //         </ul>
    //         <h5 className='font-header fw-bold'>Professional Affiliations</h5>
    //         <ul className='ps-4'>
    //           <li>Attorney at Law<br />
    //             Lawyers Council of Thailand</li>
    //           <li>People’s Dispute Mediation Center of Prince of Songkla University<br />
    //             Pro bono lawyer</li>
    //         </ul>
    //         <h5 className='font-header fw-bold'>Latest Publications</h5>
    //         <ul className='ps-4'>
    //           <li>Comparative Legal Analysis of Regulatory Frameworks for Wind Turbine Setbacks in Thailand, 2025<br />
    //             Contributor</li>
    //           <li>Low-Carbon Urban Development Report 2025<br />
    //             Contributor</li>
    //         </ul>
    //       </Col>
    //       <Col xs={12} md={8} className='px-4'>
    //         <h5 className='font-header fw-bold'>Biography</h5>
    //         <p>Supakarn Chumchuai is a junior legal associate at PT & Associates specializing in its energy, banking, finance and securities, and infrastructure and government contracts practice. His practice covered areas relating to personal data protection, anti-money laundering and counter terrorism financing, and banking regulation compliance with the Bank of Thailand. He also facilitates legal and consultancy training in banking and financial law provided by PT & Associates.</p>
    //         <h5 className='font-header fw-bold'>Experience Highlights</h5>
    //         <ul className='ps-4'>
    //           <li>Advised on a public land development initiative that structured legal compliance and commercial return optimization strategies.</li>
    //           <li>Served as legal counsel for several public-private partnership (PPP) infrastructure projects involving logistics facilities and ground handling services at a major international airport of Thailand.</li>
    //           <li>Advised on legal and policy aspects of a low-carbon urban development project in Thailand covering clean energy transition, solid waste management, wastewater treatment, and water resource optimization.</li>
    //           <li>Conducted comparative legal research on international regulatory frameworks in the renewable energy industry of Thailand, specifically on wind projects.</li>
    //           <li>Participated in an inter-disciplinary feasibility study on carbon pricing mechanisms for carbon capture and storage (CCS) solutions in the upstream petroleum industry of Thailand.</li>
    //           <li>Advised on an environmentally friendly and sustainable packaging design initiative aimed at marine litter reduction and circular plastic use through regulatory and policy enhancement in Thailand.</li>
    //           <li>Lectured on legal and financial principles for crafting long-term commercial lease agreements between state-owned enterprises and private entities in Thailand.</li>
    //         </ul>
    //       </Col>
    //     </Row>
    //   </>,
    //   row_value: Photo4,
    //   download: Profile4,
    //   enableDownload: true,
    //   enagleView: true,
    // },
    // {
    //   name: 'Miss Waralee',
    //   position: 'Legal Counsel',
    //   email: '',
    //   profile: <>Miss Waralee as a legal counsel with five years of experience who graduated from Faculty of Law, Khonkaen university. She is specialized in alternative dispute resolution, commercial and administrative law. Expertise in legal advising, legal research and negotiation. She meticulously navigated complex disputes, for construction, Infrastructures construction ensuring adherence to legal procedures and offering solutions including development of sound strategies for successful resolution.</>,
    //   row_value: Photo4
    // },
    {
      name: 'Ploykamon Ruengchaisin',
      position: 'Junior Lawyer',
      email: '',
      profile: <>
        <Row className='mb-4'>
          <Col>
            <Card className='border-0 bg-color-primary'>
              <Card.Body>
                <Row>
                  <Col xs={4} md={3}>
                    <img src={Photo9} className='w-100' />
                  </Col>
                  <Col className='p-3 text-white'>
                    <h2 className='mb-0'>Ploykamon Ruengchaisin</h2>
                    <h5 className='font-header'>Junior Lawyer</h5>
                    <div>
                      <a href='mailto:ploykamon.r@pt-assoc.com' className='text-white text-decoration-none'>
                        <AiOutlineMail size={20} className='me-1' /> ploykamon.r@pt-assoc.com
                      </a>
                      <a href={Profile8} target='_blank' className='ms-3 text-white text-decoration-none'>
                        <IoMdDownload size={20} className='me-1' />Download Profile
                      </a>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4} className='px-4'>
            <h5 className='font-header fw-bold'>Education</h5>
            <ul className='ps-4'>
              <li>LL.B. (First-Class Honors), Chulalongkorn University, 2025</li>
            </ul>
            <h5 className='font-header fw-bold'>Languages</h5>
            <ul className='ps-4'>
              <li>Thai</li>
              <li>English</li>
            </ul>
            <h5 className='font-header fw-bold'>Academic Affiliations</h5>
            <ul className='ps-4'>
              <li>Chula LegalTech<br />
                Vice President & Academic Assistant</li>
              <li>Law S.O. Society Organization<br />
                Master of Ceremonies</li>
              <li>THAC International Mediation Competition 2022<br />
                Competitor – Negotiation and Mediation</li>
              <li>Tilleke & Gibbins<br />
                Intern – Bangkok, Thailand (2025)</li>
            </ul>
            <h5 className='font-header fw-bold'>Latest Publications</h5>
            <ul className='ps-4'>
              <li>The ERC Notification Regarding the Determination of Distances for Wind Projects B.E. 2558 (2015) Law Journal<br />
                Legal Assistant </li>
              <li>Legal Reforms to Support the Transition to Low-Carbon Energy and the Legal Analysis and Enforcement through Contemporary Issues under the Framework of SDGs submitted to the King Prajadhipok’s Institute<br />
                Legal Assistant</li>
            </ul>
          </Col>
          <Col xs={12} md={8} className='px-4'>
            <h5 className='font-header fw-bold'>Biography</h5>
            <p>Ploykamon Ruengchaisin is a paralegal at PT & Associates assisting in its energy, mining, project finance, and infrastructure and government contracts practice. Her legal aptitude reflects her experience serving as a research assistant on energy and mining laws at Chulalongkorn University, while performing executive roles in Chula LegalTech. She also interned for Tilleke & Gibbins, a leading regional law firm, relating to litigation and dispute resolution. She is currently handling legal and regulatory feasibility studies related to groundbreaking smart city projects at the Eastern Economic Corridor (EEC) located in Eastern Thailand (Chonburi, Rayong and Chachoengsao). With these engagements, her practice extends to power industry mergers and acquisitions (M&A), project ownership and development, and capital markets finance.</p>
            <h5 className='font-header fw-bold'>Experience Highlights</h5>
            <ul className='ps-4'>
              <li>Participated in an inter-disciplinary feasibility study on a smart city project through the collaboration of the EEC Policy Committee and Chulalongkorn University leading to viable public-private partnership (PPP) frameworks.</li>
              <li>Prepared legal research and risk assessment reports that facilitated banking and capital markets financing for PPP energy infrastructure and utilities projects.</li>
              <li>Contributed to the regulatory study by the Energy Regulatory Commission (ERC) of Thailand concerning best practices and frameworks when it comes to wind project setbacks for community and environmental safety and protection.</li>
              <li>Contributed to the legal and policy study regarding the transition to low-carbon energy considering contemporary issues under the Sustainable Development Goals (SDGs) framework that was submitted to the King Prajadhipok’s Institute.</li>
            </ul>
          </Col>
        </Row>
      </>,
      row_value: Photo9,
      download: Profile8,
      enableDownload: true,
      enagleView: true,
    },
    {
      name: 'Prapavin Klinchan',
      position: 'Junior Lawyer',
      email: '',
      profile: <>
        <Row className='mb-4'>
          <Col>
            <Card className='border-0 bg-color-primary'>
              <Card.Body>
                <Row>
                  <Col xs={4} md={3}>
                    <img src={Photo10} className='w-100' />
                  </Col>
                  <Col className='p-3 text-white'>
                    <h2 className='mb-0'>Prapavin Klinchan</h2>
                    <h5 className='font-header'>Junior Lawyer</h5>
                    <div>
                      <a href='mailto:prapavin.k@pt-assoc.com' className='text-white text-decoration-none'>
                        <AiOutlineMail size={20} className='me-1' /> prapavin.k@pt-assoc.com
                      </a>
                      <a href={Profile8} target='_blank' className='ms-3 text-white text-decoration-none'>
                        <IoMdDownload size={20} className='me-1' />Download Profile
                      </a>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4} className='px-4'>
            <h5 className='font-header fw-bold'>Education</h5>
            <ul className='ps-4'>
              <li>LL.B. (First-Class Honors), Prince of Songkla University, 2024</li>
            </ul>
            <h5 className='font-header fw-bold'>Languages</h5>
            <ul className='ps-4'>
              <li>Thai</li>
              <li>English</li>
            </ul>
            <h5 className='font-header fw-bold'>Professional Affiliations</h5>
            <ul className='ps-4'>
              <li>Attorney at Law<br />
                LawyersCouncilofThailand</li>
              <li>Office of Phuket Summary Litigation<br />
                Intern– Phuket,Thailand</li>
            </ul>
            <h5 className='font-header fw-bold'>Publications</h5>
            <ul className='ps-4'>
              <li>Knowledge Handbook on Land Use and Utilization<br />
                Contributor</li>
              <li>Guidelines for Joint Venture
                Implementation under the Royal
                Decree Establishing the Designated
                Areas for Sustainable Tourism
                Administration (DASTA)<br />
                Contributor</li>
              <li>Development of Guidelines for
                Data Integration of Electric Vehicle
                Charging Stations<br />
                Contributor</li>
            </ul>
          </Col>
          <Col xs={12} md={8} className='px-4'>
            <h5 className='font-header fw-bold'>Biography</h5>
            <p>Prapavin Klinchan is a junior legal associate at PT & Associates specializing in
              its energy, infrastructure and area-based development and environmental
              governance. He previously interned for Office of Phuket Summary Litigation
              directly working on legal research and preparation of pleadings and court
              submissions. His practice covered areas related to the development of
              manuals on land utilization for project implementation and joint venture
              projects of DASTA, as well as matters concerning energy law.</p>
            <h5 className='font-header fw-bold'>Experience Highlights</h5>
            <ul className='ps-4'>
              <li>Conducted legal research on land utilization for the development of special areas for sustainable tourism under the DASTA, focusing on various types of land laws, restrictions and prohibitions on land use, and potential legal solutions to issues arising from DASTA’s exercise of authority.</li>
              <li>Conducted legal research on the analysis of joint venture models under the Royal Decree Establishing the Designated Areas for Sustainable Tourism Administration (Public Organization) B.E. 2546 (2003), assessing project feasibility and deriving lessons learned from DASTA’s previous project implementation experiences.</li>
              <li>Advised on the Development of Guidelines for Data Integration of Electric Vehicle Charging Stations project, providing legal  opinions related to the use and operation of electric vehicle charging equipment.</li>
              <li>Participated in an inter-disciplinary feasibility study concerning low-carbon urban development initiatives through  island-based infrastructure projects involving clean energy deployment, waste management, water treatment, and carbon reduction strategies.</li>
            </ul>
          </Col>
        </Row>
      </>,
      row_value: Photo10,
      download: Profile9,
      enableDownload: true,
      enagleView: true,
    },
  ];

  const [showModal, setShowModal] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [selectedName, setSelectedName] = useState('');

  const handleViewProfile = (name, profile) => {
    setSelectedName(name);
    setSelectedProfile(profile);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedProfile(null);
    setSelectedName('');
  };

  return (
    <>
      <section id="team" className={`pt-5 pb-5 ${bgColor}`}>
        <Container className='pt-5 pb-5'>
          {hideTopic ?
            <Row>
              <Col xs={{ span: 12, offset: 0 }} md={{ span: 8, offset: 2 }} className='mb-5 text-center'>
                <p>Our team consists of professionals who have distinguished themselves in various fields of specialization, and who could synergize theoretical mastery with practical proficiency. We provide results-oriented legal solutions directly addressing our clients’ legal and business requirements.</p>
                {/* <a href={Profile1} target='_blank' className='fs-5 tx-color-secondary text-decoration-none'>
                  <IoMdDownload /> Download Team Profiles
                </a> */}
              </Col>
            </Row>
            :
            <h1 className="font-header text-black text-center mb-5">Our Team</h1>
          }
          <Row>
            {mockup.map((item, index) => (
              hideTopic || index < 4 ? (
                <Col md={3} key={index} className={hideTopic ? 'px-3' : ''}>
                  <Card className={`rounded-0 border-0 mb-4 ${hideTopic ? '' : 'border-0'}`} style={{ backgroundColor: 'transparent' }}>
                    <div className='gradient-border position-relative mx-3'>
                      <Card.Img
                        className='ratio-1x1 bg-img bg-white'
                        style={{ backgroundImage: `url(${item.row_value})`, borderRadius: '300px' }}
                      />
                    </div>
                    <Card.Body>
                      <h5 className='text-black text-uppercase'>{item.name}</h5>
                      <h6 className='mt-2 mb-4'>
                        {item.position}
                        <div className='float-end'>
                          {item.enagleView ?
                            <button
                              className={`btn btn-link ${!hideTopic ? 'text-white' : 'tx-color-primary'} text-decoration-none p-0`}
                              onClick={() => handleViewProfile(item.name, item.profile)}
                            >
                              <FaRegEye />
                            </button>
                            : null}
                          {item.enableDownload ?
                            <a href={item.download} target='_blank'>
                              <button
                                className={`btn btn-link ${!hideTopic ? 'text-white' : 'tx-color-secondary'} text-decoration-none p-0`}
                              >
                                <IoMdDownload />
                              </button>
                            </a>
                            : null}
                        </div>
                      </h6>
                      {item.email !== '' && (
                        <div>
                          <MdOutlineKeyboardArrowRight />{' '}
                          <a href="#" className='tx-color-primary text-decoration-none'>Email</a>
                        </div>
                      )}
                      {/* <div>
                        <MdOutlineKeyboardArrowRight />{' '}
                        <button
                          className={`btn btn-link ${!hideTopic ? 'text-white' : 'tx-color-primary'} text-decoration-none p-0`}
                          onClick={() => handleViewProfile(item.name, item.profile)}
                        >
                          View Profile
                        </button>
                      </div>
                      <div>
                        <IoMdDownload />{' '}
                        <a href={item.download} target='_blank'>
                          <button
                            className={`btn btn-link ${!hideTopic ? 'text-white' : 'tx-color-secondary'} text-decoration-none p-0`}
                          >
                            Download Profile
                          </button>
                        </a>
                      </div> */}
                    </Card.Body>
                  </Card>
                </Col>
              ) : null
            ))}
          </Row>
          {!hideTopic ?
            <Row>
              <Col className='text-center pt-5'>
                <Button as={Link} to='/OurTeam' className='px-5 bg-white tx-color-primary fw-bold border-0'>
                  View More
                </Button>
              </Col>
            </Row>
            : null}
        </Container>
      </section>

      {/* Modal for Profile */}
      <Modal show={showModal} size='xl' onHide={handleCloseModal}>
        <Modal.Header className='px-4' closeButton>
          <Modal.Title>Team Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-4'>{selectedProfile}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

SectionTeam.defaultProps = {
  contents: []
};

export default SectionTeam;
